import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld';
import Tenant from '@/components/Tenant';
// import Login from '@/components/Login';
// import LoginDD from '@/components/LoginDD';
// import NotFound from '@/components/404';

Vue.use(Router);

const routes = [{
    path: '/',
    name: 'default',
    // redirect: '/dashboard'
    redirect: '/tenant'
  },
  {
    path: '/tenant',
    name: 'tenant',
    component: Tenant,
    meta: {
      title: 'Tenant'
        // keepAlive: true // 需要被缓存
    }
  } // ,
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login,
  //   meta: {
  //     title: '登录'
  //       // keepAlive: true // 需要被缓存
  //   }
  // },
  // {
  //   path: '/loginDD',
  //   name: 'loginDD',
  //   component: LoginDD,
  //   meta: {
  //     title: '登录'
  //       // keepAlive: true // 需要被缓存
  //   }
  // },
  // {
  //   path: '/contractList',
  //   name: 'contractList',
  //   component: resolve => (require(['@/views/Contracts/contractList'], resolve)),
  //   meta: { title: '合同订单', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/SearchProduct',
  //   name: 'searchProduct',
  //   component: resolve => (require(['@/views/Products/SearchProduct'], resolve)),
  //   meta: { title: '查找加密锁', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/SearchContract',
  //   name: 'searchContract',
  //   component: resolve => (require(['@/views/Contracts/SearchContract'], resolve)),
  //   meta: { title: '查找合同', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/ProductContractList/:productCode',
  //   name: 'productContractList',
  //   props: true,
  //   component: resolve => (require(['@/views/Products/ProductContractList'], resolve)),
  //   meta: { title: '生成开锁文件', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/ContractProductList/:contractId',
  //   name: 'contractProductList',
  //   component: resolve => (require(['@/views/Contracts/ContractProductList'], resolve)),
  //   props: true,
  //   meta: { title: '合同订单', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/ProductFileList/:productCode',
  //   name: 'productFileList',
  //   component: resolve => (require(['@/views/Products/ProductFileList'], resolve)),
  //   props: true,
  //   meta: { title: '开锁记录', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/FileContent',
  //   name: 'fileContent',
  //   component: resolve => (require(['@/views/Products/FileContent'], resolve)),
  //   props: true,
  //   meta: { title: '文件详情', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/BuildDogFile',
  //   name: 'buildDogFile',
  //   component: resolve => (require(['@/views/Products/BuildDogFile'], resolve)),
  //   props: true,
  //   meta: { title: '生成开锁文件', requiresAuth: true, keepAlive: true }
  // },
  // {
  //   path: '/404',
  //   component: NotFound,
  //   hidden: true
  // },
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
];

export default new Router({
  routes,
  mode: 'history',
  
  // * 不是所有流浪器都支持 history 模式，如果遇到不支持的时候，需要设置 fallback 为 true，它会自动帮我们转成哈希去处理
  // * 如果你设置成 false，在不支持的情况下，那么单应用就会变成多应用，你每次路由跳转都会去后端然后返回新的内容，所以一般都是设置成 ture 要它去自动处理就好了
  fallback: true
});


// WEBPACK FOOTER //
// ./src/router/index.js